import React, { useState, useEffect } from 'react'
import { Clock } from 'lucide-react'

const CountdownTimer = ({ targetDate }) => {
  const [timeLeft, setTimeLeft] = useState('')
  const [isExpired, setIsExpired] = useState(false)
  const [urgency, setUrgency] = useState('normal')

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date().getTime()
      const target = new Date(targetDate).getTime()
      const difference = target - now

      if (difference > 0) {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24))
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60))
        const seconds = Math.floor((difference % (1000 * 60)) / 1000)

        // Determine urgency based on time left
        const totalHours = difference / (1000 * 60 * 60)
        if (totalHours <= 2) {
          setUrgency('critical')
        } else if (totalHours <= 24) {
          setUrgency('high')
        } else if (totalHours <= 72) {
          setUrgency('medium')
        } else {
          setUrgency('normal')
        }

        if (days > 0) {
          setTimeLeft(`${days}d ${hours}h ${minutes}m`)
        } else if (hours > 0) {
          setTimeLeft(`${hours}h ${minutes}m ${seconds}s`)
        } else {
          setTimeLeft(`${minutes}m ${seconds}s`)
        }
        setIsExpired(false)
      } else {
        setTimeLeft('Expirado')
        setIsExpired(true)
        setUrgency('expired')
      }
    }, 1000)

    return () => clearInterval(timer)
  }, [targetDate])

  const getUrgencyStyles = () => {
    switch (urgency) {
      case 'expired':
        return 'bg-gray-100 text-gray-600 border border-gray-300'
      case 'critical':
        return 'bg-red-100 text-red-800 border border-red-200'
      case 'high':
        return 'bg-orange-100 text-orange-800 border border-orange-200'
      case 'medium':
        return 'bg-yellow-100 text-yellow-800 border border-yellow-200'
      default:
        return 'bg-green-100 text-green-800 border border-green-200'
    }
  }

  return (
    <div className={`flex items-center gap-2 px-3 py-1 rounded-full text-sm font-medium ${getUrgencyStyles()}`}>
      <Clock className="w-4 h-4" />
      <span>{isExpired ? '⏰ Expirado' : `⏱️ ${timeLeft}`}</span>
    </div>
  )
}

export default CountdownTimer